import script from "./AddButton.vue?vue&type=script&setup=true&lang=ts"
export * from "./AddButton.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__